'use strict';
/**
 * @requires ../node_modules/fuzzysort/fuzzysort.js
 */

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GhostSearch =
/*#__PURE__*/
function () {
  function GhostSearch(args) {
    _classCallCheck(this, GhostSearch);

    this.check = false;
    var defaults = {
      host: 'http://192.168.1.156:2368',
      key: 'ea5003581f252f5867bfdcceaf',
      version: 'v3',
      input: '#search-field',
      results: '#results',
      button: '',
      defaultValue: '',
      template: function template(result) {
        var url = [location.protocol, '//', location.host].join('');
        return '<a href="' + url + '/' + result.slug + '/">' + result.title + '</a>';
      },
      trigger: 'focus',
      options: {
        keys: ['title'],
        limit: 10,
        threshold: -3500,
        allowTypo: false
      },
      api: {
        resource: 'posts',
        parameters: {
          limit: 'all',
          fields: ['title', 'slug'],
          filter: '',
          include: '',
          order: '',
          formats: '',
          page: ''
        }
      },
      on: {
        beforeDisplay: function beforeDisplay() {},
        afterDisplay: function afterDisplay(results) {},
        beforeFetch: function beforeFetch() {},
        afterFetch: function afterFetch(results) {}
      }
    };
    var merged = this.mergeDeep(defaults, args);
    Object.assign(this, merged);
    this.init();
  }

  _createClass(GhostSearch, [{
    key: "mergeDeep",
    value: function mergeDeep(target, source) {
      var _this = this;

      if (target && _typeof(target) === 'object' && !Array.isArray(target) && target !== null && source && _typeof(source) === 'object' && !Array.isArray(source) && source !== null) {
        Object.keys(source).forEach(function (key) {
          if (source[key] && _typeof(source[key]) === 'object' && !Array.isArray(source[key]) && source[key] !== null) {
            if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));

            _this.mergeDeep(target[key], source[key]);
          } else {
            Object.assign(target, _defineProperty({}, key, source[key]));
          }
        });
      }

      return target;
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var _this2 = this;

      this.on.beforeFetch();
      var ghostAPI = new GhostContentAPI({
        host: this.host,
        key: this.key,
        version: this.version
      });
      var browse = {};
      var parameters = this.api.parameters;

      for (var key in parameters) {
        if (parameters[key] != '') {
          browse[key] = parameters[key];
        }
      }

      ghostAPI[this.api.resource].browse(browse).then(function (data) {
        _this2.search(data);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: "createElementFromHTML",
    value: function createElementFromHTML(htmlString) {
      var div = document.createElement('div');
      div.innerHTML = htmlString.trim();
      return div.firstChild;
    }
  }, {
    key: "displayResults",
    value: function displayResults(data) {
      if (document.querySelectorAll(this.results)[0].firstChild !== null && document.querySelectorAll(this.results)[0].firstChild !== '') {
        while (document.querySelectorAll(this.results)[0].firstChild) {
          document.querySelectorAll(this.results)[0].removeChild(document.querySelectorAll(this.results)[0].firstChild);
        }
      }

      ;
      var inputValue = document.querySelectorAll(this.input)[0].value;

      if (this.defaultValue != '') {
        inputValue = this.defaultValue;
      }

      var results = fuzzysort.go(inputValue, data, {
        keys: this.options.keys,
        limit: this.options.limit,
        allowTypo: this.options.allowTypo,
        threshold: this.options.threshold
      });

      for (var key in results) {
        if (key < results.length) {
          document.querySelectorAll(this.results)[0].appendChild(this.createElementFromHTML(this.template(results[key].obj)));
        }

        ;
      }

      this.on.afterDisplay(results);
      this.defaultValue = '';
    }
  }, {
    key: "search",
    value: function search(data) {
      var _this3 = this;

      this.on.afterFetch(data);
      this.check = true;

      if (this.defaultValue != '') {
        this.on.beforeDisplay();
        this.displayResults(data);
      }

      if (this.button != '') {
        var button = document.querySelectorAll(this.button)[0];

        if (button.tagName == 'INPUT' && button.type == 'submit') {
          button.closest('form').addEventListener("submit", function (e) {
            e.preventDefault();
          });
        }

        ;
        button.addEventListener('click', function (e) {
          e.preventDefault();

          _this3.on.beforeDisplay();

          _this3.displayResults(data);
        });
      } else {
        document.querySelectorAll(this.input)[0].addEventListener('keyup', function (e) {
          _this3.on.beforeDisplay();

          _this3.displayResults(data);
        });
      }

      ;
    }
  }, {
    key: "checkArgs",
    value: function checkArgs() {
      if (!document.querySelectorAll(this.input).length) {
        console.log('Input not found.');
        return false;
      }

      if (!document.querySelectorAll(this.results).length) {
        console.log('Results not found.');
        return false;
      }

      ;

      if (this.button != '') {
        if (!document.querySelectorAll(this.button).length) {
          console.log('Button not found.');
          return false;
        }

        ;
      }

      if (this.host == '') {
        console.log('Content API Client Library host missing. Please set the host. Must not end in a trailing slash.');
        return false;
      }

      ;

      if (this.key == '') {
        console.log('Content API Client Library key missing. Please set the key. Hex string copied from the "Integrations" screen in Ghost Admin.');
        return false;
      }

      ;
      return true;
    }
  }, {
    key: "validate",
    value: function validate() {
      if (!this.checkArgs()) {
        return false;
      }

      ;
      return true;
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;

      if (!this.validate()) {
        return;
      }

      if (this.defaultValue != '') {
        document.querySelectorAll(this.input)[0].value = this.defaultValue;

        window.onload = function () {
          if (!_this4.check) {
            _this4.fetch();
          }

          ;
        };
      }

      if (this.trigger == 'focus') {
        document.querySelectorAll(this.input)[0].addEventListener('focus', function (e) {
          if (!_this4.check) {
            _this4.fetch();
          }

          ;
        });
      } else if (this.trigger == 'load') {
        window.onload = function () {
          if (!_this4.check) {
            _this4.fetch();
          }

          ;
        };
      }
    }
  }]);

  return GhostSearch;
}();
